var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reward-item d-inline-flex align-items-center me-1"},[_c('img',{staticClass:"reward-icon me-1",attrs:{"draggable":"false","src":_vm.rewardIcon}}),_c('span',{staticClass:"reward-amount blue"},[_vm._v(_vm._s(_vm.rewardAmount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }